/**
 * Token storage - Dual mode security layer.
 * 
 * PRIMARY: httpOnly cookies set by the backend on /auth/login and /auth/refresh.
 * SECONDARY: sessionStorage used as client-side cache for fast auth state checks.
 * sessionStorage is preferred over localStorage because:
 *   - Data is cleared when the tab/window is closed
 *   - Not shared across tabs (limits XSS blast radius)
 *   - Still fast for same-session auth state detection
 * 
 * Migration path: When ready, remove sessionStorage entirely and rely only on
 * httpOnly cookies + /auth/me for state detection.
 */

const STORAGE = typeof window !== 'undefined' ? window.sessionStorage : null;

const tokenStore = {
  getToken: () => STORAGE?.getItem('token') || null,
  setToken: (token) => STORAGE?.setItem('token', token),
  getRefreshToken: () => STORAGE?.getItem('refresh_token') || null,
  setRefreshToken: (token) => STORAGE?.setItem('refresh_token', token),
  clear: () => {
    STORAGE?.removeItem('token');
    STORAGE?.removeItem('refresh_token');
  },
};

export default tokenStore;
